// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1857":"adf34865","5954":"adf34865"}[chunkId] + ".chunk.css";
};